import { flow } from 'lodash';
import Carousel from './Carousel';
import withUserInput from '../../hocs/UserInput';
import withPager from '../../hocs/Pager';

export default flow(withUserInput, withPager)(Carousel);



// WEBPACK FOOTER //
// ../core/src/components/Carousel/index.js